import { IonCard, IonCardHeader, IonCardTitle } from '@ionic/react';
import { ReactElement } from 'react';
import { Machine } from '../../../api/graphql/generated';
import i18n from '../../../i18n';
import { useBeaconRouter } from '../../../route/route.hooks';
import './card.css';
interface LicensesCardProps {
  machine?: Machine;
}

const ApplicationsCard = (props: LicensesCardProps): ReactElement => {
  const { machine } = props;

  const { builder } = useBeaconRouter();

  return (
    <IonCard
      className="machine-card-container"
      routerLink={
        machine
          ? builder.getMachineApplicationsRoute(machine.teamId, machine.id)
          : undefined
      }
    >
      <IonCardHeader>
        <IonCardTitle>{i18n.t('common:machine_applications')}</IonCardTitle>
      </IonCardHeader>
      <p className="card-description">
        {i18n.t('common:machine_applications_desc')}
      </p>
    </IonCard>
  );
};

export { ApplicationsCard };
